import { render, staticRenderFns } from "./AllPaySlipDetails.vue?vue&type=template&id=40f317a2&scoped=true&"
import script from "./AllPaySlipDetails.vue?vue&type=script&lang=js&"
export * from "./AllPaySlipDetails.vue?vue&type=script&lang=js&"
import style0 from "./AllPaySlipDetails.vue?vue&type=style&index=0&id=40f317a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f317a2",
  null
  
)

export default component.exports